import React, { useState } from 'react';
import { Layout, Menu, Radio, DatePicker } from 'antd';
import { Row, Col } from 'react-bootstrap';

const { Header, Content, Sider } = Layout;

const AppointmentScheduler = () => {
    const [selectedTime, setSelectedTime] = useState(null);

    const handleTimeSelect = (e) => {
        setSelectedTime(e.target.value);
    };

    return (
        <Layout style={{ minHeight: '100vh' }}>
            <Sider width={256} style={{ background: '#fff' }}>
                <Menu mode="inline" defaultSelectedKeys={['1']}>
                    <Menu.Item key="1">All Doctors</Menu.Item>
                    <Menu.Item key="2">Dr. Divyesh Limbasiya</Menu.Item>
                    <Menu.Item key="3">Other Doctors</Menu.Item>
                </Menu>
            </Sider>

            <Layout>
                <Header style={{ background: '#fff', padding: '0 20px' }}>
                    <h2>Appointments</h2>
                    <DatePicker />
                </Header>

                <Content style={{ padding: '20px' }}>
                    <h3>Morning (09:00 AM to 01:00 PM)</h3>
                    <Radio.Group onChange={handleTimeSelect} value={selectedTime}>
                        <Row>
                            {Array.from({ length: 48 }, (_, index) => (
                                <Col key={index} xs={3}>
                                    <Radio value={index + 1}>{index + 1}</Radio>
                                </Col>
                            ))}
                        </Row>
                    </Radio.Group>
                </Content>
            </Layout>
        </Layout>
    );
};

export default AppointmentScheduler;